<template>
    <div>
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">Aprovações pendentes</div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <!-- Tabela com operadores opcionais para evitar erros -->
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">ID</th>
                                            <th scope="col">Nome de Usuário</th>
                                            <th scope="col">Veículo</th>
                                            <th scope="col">Placa Veículo</th>
                                            <th scope="col">Data da Reserva</th>
                                            <th scope="col">Data de Retirada</th>
                                            <th scope="col">Data de Devolução</th>
                                            <th scope="col">Filial</th>
                                            <th scope="col">Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="reservesCount > 0">
                                        <tr
                                            v-for="(reserve, index) in reserves"
                                            :key="reserve.id"
                                        >
                                            <td>{{ reserve.id }}</td>
                                            <td>{{ reserve.user ? reserve.user.name : 'N/A' }}</td>
                                            <td>{{ getVehicleDescription(reserve) }}</td>
                                            <td>{{ getVehicleBoard(reserve) }}</td>
                                            <td>{{ reserve.created_at }}</td>
                                            <td>{{ reserve.retreat_date }}</td>
                                            <td>{{ reserve.devolution_date }}</td>
                                            <td>{{ reserve.branch ? reserve.branch.description : 'N/A' }}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    class="btn btn-crud view"
                                                    data-tooltip="tooltip"
                                                    title="Visualizar"
                                                    @click="modalReserva(index)"
                                                >
                                                    <i class="far fa-eye"></i>
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="9"
                                                align="center"
                                            >
                                                Nenhuma reserva pendente de aprovação.
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">Histórico de moderação</div>
                        </div>
                        <div
                            class="card-body"
                            v-if="reloaded"
                        >
                            <base-crud
                                crudName
                                newText="Nova Reserva"
                                :table="table"
                                :columns="columns"
                                :options="options"
                                :endPoint="endPoint"
                                :enableAdd="false"
                                :enableEdit="false"
                                :enableDelete="false"
                                :enableView="false"
                                :dataForm="dataForm"
                                :customFilters="customFilters"
                                @rDate="rDate"
                                @reDate="reDate"
                                @dDate="dDate"
                                @mDate="mDate"
                                :extra="extra"
                                @view="view"
                            ></base-crud>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Moderação -->
        <BaseModal
            :isVisible="moderationModal.show && reservesCount > 0"
            title="Informações da pré-reserva"
            size="lg"
            @close="closeModerationModal"
        >
            <template v-slot:content>
                <div v-if="selectedReserve">
                    <SectionContainer
                        title="Dados da Pré-reserva"
                        icon="hourglass-half"
                    >
                        <!-- Header com imagem e informações principais -->
                        <div class="reservation-header">
                            <div class="vehicle-section">
                                <div class="vehicle-image-container">
                                    <img
                                        class="vehicle-image"
                                        :src="selectedReserve.vehicles.photo"
                                        alt="Foto do veículo"
                                    />
                                    <div class="vehicle-badge">
                                        {{ getVehicleDescription(selectedReserve) }}
                                        <div class="plate-container">
                                            <i class="fas fa-car-side"></i>
                                            {{ getVehicleBoard(selectedReserve) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="status-section">
                                <div class="status-info">
                                    <span class="status-badge status-pending">
                                        Pré-reserva
                                    </span>
                                    <div class="reservation-id">
                                        #{{ selectedReserve.id }}
                                    </div>
                                </div>

                                <div class="user-info">
                                    <i class="fas fa-user text-primary"></i>
                                    <span>{{ selectedReserve.user.name }}</span>
                                </div>

                                <div class="info-card">
                                    <div class="card-icon">
                                        <i class="fas fa-comment-alt"></i>
                                    </div>
                                    <div class="card-content">
                                        <div class="card-label">Motivo da Reserva:</div>
                                        <div class="card-value">{{ selectedReserve.reason || 'Não informado' }}</div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <!-- Grid de informações em cards -->
                        <div class="info-cards-grid">
                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-calendar-plus"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Data da Reserva:</div>
                                    <div class="card-value orange">{{ selectedReserve.created_at }}</div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-calendar-alt"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Retirada Estimada:</div>
                                    <div class="card-value orange">{{ selectedReserve.retreat_date }}</div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-calendar-times"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Devolução Estimada:</div>
                                    <div class="card-value orange">{{ selectedReserve.devolution_date }}</div>
                                </div>
                            </div>

                            <div class="info-card" v-if="selectedReserve.km_traveled">
                                <div class="card-icon">
                                    <i class="fas fa-tachometer-alt"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Km Rodados:</div>
                                    <div class="card-value blue">{{ formatKilometers(selectedReserve.km_traveled) }} km</div>
                                </div>
                            </div>
                        </div>

                        <!-- Campo de observação -->
                        <div class="observation-section">
                            <SectionContainer
                                title="Observação da Moderação"
                                icon="edit"
                            >
                                <div class="form-group">
                                    <label for="observation" class="required-field">
                                        <span class="required">*</span>
                                        Observação:
                                    </label>
                                    <textarea
                                        id="observation"
                                        class="form-control"
                                        v-model="observation"
                                        rows="4"
                                        placeholder="Digite aqui sua observação sobre a análise da pré-reserva..."
                                        :class="{ 'is-invalid': !observation.trim() }"
                                    ></textarea>
                                    <small class="form-text text-muted">
                                        Campo obrigatório para aprovar ou reprovar a pré-reserva.
                                    </small>
                                </div>

                                <div class="action-buttons">
                                    <button
                                        class="btn btn-success btn-block"
                                        @click="approve(selectedReserve.id)"
                                        :disabled="!observation.trim()"
                                        title="Aprovar Pré-reserva"
                                    >
                                        <i class="fas fa-check mr-2"></i>
                                        Aprovar
                                    </button>
                                    <button
                                        class="btn btn-danger btn-block mt-0"
                                        @click="reject(selectedReserve.id)"
                                        :disabled="!observation.trim()"
                                        title="Reprovar Pré-reserva"
                                    >
                                        <i class="fas fa-times mr-2"></i>
                                        Reprovar
                                    </button>
                                </div>

                            </SectionContainer>
                        </div>
                    </SectionContainer>
                </div>
            </template>
        </BaseModal>

        <!-- Modal Histórico -->
        <BaseModal
            :isVisible="historyModal.show"
            title="Informações da Reserva"
            size="lg"
            @close="closeHistoryModal"
        >
            <template v-slot:content>
                <SectionContainer
                    title="Histórico da Moderação"
                    icon="history"
                >
                    <!-- Header com imagem e informações principais -->
                    <div class="reservation-header">
                        <div class="vehicle-section">
                            <div class="vehicle-image-container">
                                <img
                                    class="vehicle-image"
                                    :src="historyData.photo"
                                    alt="Foto do veículo"
                                />
                                <div class="vehicle-badge">
                                    {{ historyData.vehicleDescription }}
                                    <div class="plate-container">
                                        <i class="fas fa-car-side"></i>
                                        {{ historyData.vehicleBoard }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="status-section">
                            <div class="status-info">
                                <span
                                    class="status-badge"
                                    :class="getHistoryStatusClass(historyData.status)"
                                >
                                    {{ historyData.status ? historyData.status : 'Aprovação automática' }}
                                </span>
                                <div class="reservation-id">
                                    #{{ historyData.reserveId }}
                                </div>
                            </div>

                            <div class="user-info">
                                <i class="fas fa-user text-primary"></i>
                                <span>{{ historyData.userReserve }}</span>
                            </div>

                            <div class="moderator-info">
                                <i class="fas fa-user-tie text-success"></i>
                                <span>Analisado por: {{ historyData.moderated_by }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Grid de informações em cards -->
                    <div class="info-cards-grid">
                        <div class="info-card">
                            <div class="card-icon">
                                <i class="fas fa-calendar-plus"></i>
                            </div>
                            <div class="card-content">
                                <div class="card-label">Data da Reserva:</div>
                                <div class="card-value orange">{{ historyData.created_at }}</div>
                            </div>
                        </div>

                        <div class="info-card">
                            <div class="card-icon">
                                <i class="fas fa-calendar-alt"></i>
                            </div>
                            <div class="card-content">
                                <div class="card-label">Retirada Estimada:</div>
                                <div class="card-value orange">{{ historyData.retreat_date }}</div>
                            </div>
                        </div>

                        <div class="info-card">
                            <div class="card-icon">
                                <i class="fas fa-calendar-times"></i>
                            </div>
                            <div class="card-content">
                                <div class="card-label">Devolução Estimada:</div>
                                <div class="card-value orange">{{ historyData.devolution_date }}</div>
                            </div>
                        </div>

                        <div class="info-card" v-if="historyData.moderated_at">
                            <div class="card-icon">
                                <i class="fas fa-clock"></i>
                            </div>
                            <div class="card-content">
                                <div class="card-label">Analisado em:</div>
                                <div class="card-value">{{ historyData.moderated_at }}</div>
                            </div>
                        </div>

                        <div class="info-card">
                            <div class="card-icon">
                                <i class="fas fa-tachometer-alt"></i>
                            </div>
                            <div class="card-content">
                                <div class="card-label">Km Rodados:</div>
                                <div class="card-value blue">{{ formatKilometers(historyData.vehicleKM) }} km</div>
                            </div>
                        </div>
                    </div>

                    <!-- Observação da moderação -->
                    <div class="observation-section">
                        <SectionContainer
                            title="Observação da Moderação"
                            icon="comment"
                        >
                            <div class="observation-display mt-3">
                                {{ historyData.observation || 'Nenhuma observação registrada.' }}
                            </div>
                        </SectionContainer>
                    </div>
                </SectionContainer>
            </template>
        </BaseModal>

        <loading
            :active.sync="isLoading"
            :is-full-page="true"
        ></loading>
    </div>
</template>

<script>
import '../../assets/css/moderation-reserve.css'
import Loading from "vue-loading-overlay";
import BaseCrud from "../Base/BaseCrud";
import BaseModal from "../Base/BaseModal.vue";
import SectionContainer from "../Modals/Checklist/SectionContainer.vue";
import { getMessage } from "../../composables/message";
import {shouldHideVehicleData} from "../../composables/useVehicleVisibility";

export default {
    components: {
        BaseCrud,
        Loading,
        BaseModal,
        SectionContainer
    },
    data() {
        return {
            // Controle dos modais
            moderationModal: { // moderationModal - controle do modal de moderação
                show: false
            },
            historyModal: { // historyModal - controle do modal de histórico
                show: false
            },

            // Dados dos modais
            selectedReserve: null, // selectedReserve - reserva selecionada para moderação
            historyData: { // historyData - dados do histórico sendo visualizado
                photo: "",
                vehicleDescription: "",
                vehicleBoard: "",
                userReserve: "",
                created_at: "",
                retreat_date: "",
                devolution_date: "",
                vehicleKM: "",
                moderated_by: "",
                moderated_at: "",
                status: "",
                observation: "",
                reserveId: ""
            },

            customFilters: [
                {
                    name: "retreat_date",
                    type: "calendar",
                    call: "rDate",
                },
                {
                    name: "devolution_date",
                    type: "calendar",
                    call: "dDate",
                },
                {
                    name: "created_at",
                    type: "calendar",
                    call: "reDate",
                },
                {
                    name: "moderated_at",
                    type: "calendar",
                    call: "mDate",
                },
            ],

            reloaded: true,
            isLoading: false,
            retreat_date: "",
            devolution_date: "",
            moderated_at: "",
            observation: "", // observation - observação da moderação

            /* Base Crud Histórico */
            table: "moderationTable",
            columns: [
                "id",
                "user_id",
                "created_at",
                "retreat_date",
                "devolution_date",
                "moderated_at",
                "moderated_by",
                "status",
                "actions",
            ],
            tableData: [
                "id",
                "user_id",
                "created_at",
                "retreat_date",
                "devolution_date",
                "moderated_at",
                "moderated_by",
                "status",
            ],
            options: {
                filterByColumn: true,
                debounce: 1000,
                filterable: ["id", "user_id", "moderated_by", "status"],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    user_id: "Nome do Usuário",
                    created_at: "Data de Reserva",
                    retreat_date: "Data de Retirada",
                    devolution_date: "Data de Devolução",
                    moderated_at: "Analisado em",
                    moderated_by: "Analisado por",
                    status: "Status",
                    actions: "Ações",
                },
                texts: {
                    filterBy: "Filtrar",
                    defaultOption: "Selecione",
                },
                listColumns: {
                    status: [
                        {
                            id: "Aprovado",
                            text: "Aprovado",
                        },
                        {
                            id: "Rejeitado",
                            text: "Rejeitado",
                        },
                    ],
                },
                templates: {
                    user_id: function (h, row, index) {
                        return row.user ? row.user.name : "Sem Nome";
                    },
                    moderated_at: function (h, row, index) {
                        return row.moderation ? row.moderation.created_at : "N/A";
                    },
                    moderated_by: function (h, row, index) {
                        return row.moderated_by ? row.moderated_by.name : "N/A";
                    },
                    status: function (h, row, index) {
                        return row.moderation && row.moderation.moderated_status
                            ? row.moderation.moderated_status
                            : "Aprovação automática";
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;

                    if (
                        this.$parent.$parent.retreat_date != null &&
                        this.$parent.$parent.retreat_date != ""
                    ) {
                        requestData.params.retreat_date = this.$parent.$parent.retreat_date;
                    }

                    if (
                        this.$parent.$parent.devolution_date != null &&
                        this.$parent.$parent.devolution_date != ""
                    ) {
                        requestData.params.devolution_date =
                            this.$parent.$parent.devolution_date;
                    }

                    if (
                        this.$parent.$parent.moderated_at != null &&
                        this.$parent.$parent.moderated_at != ""
                    ) {
                        requestData.params.moderated_at = this.$parent.$parent.moderated_at;
                    }

                    requestData.params.query = "";
                    requestData.params.with = [
                        "user",
                        "moderated_by",
                        "vehicles",
                        "moderation",
                    ];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "fas fa-eye btn btn-crud view2",
                    title: "Visualizar",
                    name: "view",
                    icon: "btn btn-crud view",
                },
            ],
            endPoint: "reserveVehicles/",
            dataForm: {},

            reserves: [ // reserves - lista de reservas pendentes
                {
                    vehicle: {
                        description: "",
                        photo: "",
                    },
                    user: {
                        name: "",
                        photo: "",
                    },
                    moderated_by: {
                        name: "",
                        photo: "",
                    },
                },
            ],
            index: 0,
            errors: undefined,
            reservesCount: "", // reservesCount - quantidade de reservas pendentes
        };
    },

    methods: {
        getVehicleDescription(reserve) {
            const user = this.$store.state.user;
            if (!reserve || !reserve.vehicles) return 'N/A';
            if (shouldHideVehicleData(user, reserve)) {
                return 'Veículo Oculto';
            }
            return reserve.vehicles.description;
        },
        getVehicleBoard(reserve) {
            const user = this.$store.state.user;
            if (!reserve || !reserve.vehicles) return 'N/A';
            if (shouldHideVehicleData(user, reserve)) {
                return '***-***';
            }
            return reserve.vehicles.board;
        },
        getHistoryStatusClass(status) {
            const statusClasses = {
                'Aprovado': 'status-approved',
                'Rejeitado': 'status-canceled'
            };
            return statusClasses[status] || 'status-approved';
        },

        // formatKilometers - formata quilometragem com separadores
        formatKilometers(value) {
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },

        // closeModerationModal - fecha modal de moderação
        closeModerationModal() {
            this.moderationModal.show = false;
            this.selectedReserve = null;
            this.observation = "";
        },

        // closeHistoryModal - fecha modal de histórico
        closeHistoryModal() {
            this.historyModal.show = false;
            this.historyData = {
                photo: "",
                vehicleDescription: "",
                vehicleBoard: "",
                userReserve: "",
                created_at: "",
                retreat_date: "",
                devolution_date: "",
                vehicleKM: "",
                moderated_by: "",
                moderated_at: "",
                status: "",
                observation: "",
                reserveId: ""
            };
        },

        rDate(date) {
            this.retreat_date = date;
        },
        reDate(date) {
            this.created_at = date;
        },
        dDate(date) {
            this.devolution_date = date;
        },
        mDate(date) {
            this.moderated_at = date;
        },
        query: function (query) {
            let columns = {
                id: "id",
                user_id: "user[name]",
                created_at: "created_at",
                retreat_date: "retreat_date",
                devolution_date: "devolution_date",
                moderated_at: "moderation[created_at]",
                vehicle_id: "vehicles[description]",
                vehicle_board: "vehicles[board]",
                status: "moderation[moderated_status]",
            };
            let filters = "moderated_at=1&";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },

        // getReserves - busca reservas pendentes de aprovação
        getReserves: function (id) {
            const self = this;
            let api =
                self.$store.state.api +
                `reserveVehicles/?reserve_status=1&with[]=user&with[]=branch&with[]=vehicle_type_id&with[]=vehicles`;

            self.$http
                .get(api)
                .then((response) => {
                    self.reloaded = false
                    self.reserves = response.data.data;
                    self.reservesCount = response.data.count;
                    setTimeout(() => {
                        self.reloaded = true
                    }, 50)
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        // modalReserva - abre modal de moderação
        modalReserva(index) {
            this.selectedReserve = this.reserves[index];
            this.moderationModal.show = true;
        },

        // view - abre modal de histórico
        view: function (props, row, index) {
            this.historyData = {
                photo: props.row.vehicles.photo,
                vehicleDescription: props.row.vehicles.description,
                vehicleBoard: props.row.vehicles.board,
                userReserve: props.row.user.name,
                created_at: props.row.created_at,
                retreat_date: props.row.retreat_date,
                devolution_date: props.row.devolution_date,
                vehicleKM: props.row.vehicles.current_km,
                moderated_by: props.row.moderated_by ? props.row.moderated_by.name : 'Aprovação automática',
                moderated_at: props.row.moderation ? props.row.moderation.created_at : '',
                status: props.row.moderation ? props.row.moderation.moderated_status : '',
                observation: props.row.moderation ? props.row.moderation.observation : '',
                reserveId: props.row.id
            };
            this.historyModal.show = true;
        },

        // approve - aprova a pré-reserva
        approve(id) {
            if (!this.observation.trim()) {
                this.$message(null, 'Observação é obrigatória', 'error');
                return;
            }

            const self = this;
            let api = self.$store.state.api + "reserveVehicles/" + id;
            let fd = new FormData();

            fd.append("_method", "PATCH");
            fd.append("op", "moderation");
            fd.append("reserve_status", "2");
            fd.append("observation", self.observation);
            fd.append("moderated_at", "1");
            fd.append("moderated_status", "Aprovado");
            fd.append("moderated_by", self.$store.state.user.id);

            self.isLoading = true;

            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message("Sucesso", `Pré-reserva aprovada`, "success");
                    self.closeModerationModal();
                    self.getReserves();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                })
                .finally(() => {
                    setTimeout(() => {
                        self.isLoading = false;
                    }, 200)
                });
        },

        // reject - rejeita a pré-reserva
        reject(id) {
            if (!this.observation.trim()) {
                this.$message(null, 'Observação é obrigatória', 'error');
                return;
            }

            const self = this;
            let api = self.$store.state.api + "reserveVehicles/" + id;
            let fd = new FormData();

            fd.append("_method", "PATCH");
            fd.append("op", "moderation");
            fd.append("reserve_status", "3");
            fd.append("observation", self.observation);
            fd.append("moderated_at", "1");
            fd.append("moderated_status", "Rejeitado");
            fd.append("moderated_by", self.$store.state.user.id);

            self.isLoading = true;
            self.$http
                .post(api, fd)
                .then((response) => {
                    self.$message("Sucesso", `Pré-reserva rejeitada`, "success");
                    self.closeModerationModal();
                    self.getReserves();
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                })
                .finally(() => {
                    setTimeout(() => {
                        self.isLoading = false;
                    }, 200)
                });
        },
    },

    mounted: function () {
        const self = this;
        self.getReserves();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/ReserveModeration/Moderation.vue